var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vmp-volume-preview",attrs:{"id":"vmp-volume-preview"}},[_c('div',{staticClass:"vmp-volume-preview-current",style:(_vm.widthStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }